import jQuery from 'jquery';
import React from 'react';
import Alert from 'react-bootstrap/Alert';
import * as echarts from 'echarts';

import Request from '@scripts/request.js';
import CurrencyFormat from '@scripts/utilities/currency.js';
import Throttle from '@scripts/utilities/throttle.js';

import Spinner from '../Spinner/index.jsx';
import UpdatedPopover from '../UpdatedPopover/index.jsx';


var dateAxisFormat = function(value) {
  return new Date(parseInt(value)).toLocaleDateString(
    undefined, { month: 'short', day: 'numeric' }
  );
};

var tooltipDateFormat = function(value) {
  return new Date(parseInt(value)).toLocaleDateString(
    undefined,
    { year: 'numeric', month: 'long', day: 'numeric' }
  );
}


class LineChart extends React.Component {
  constructor(props) {
    super(props);

    this.chart = React.createRef();

    this.chartInstance = undefined;

    this.onResize = Throttle(this.onResize.bind(this), 150);
    this.onTabShown = this.onTabShown.bind(this);
  }

  onResize() {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  /**
   * when a tab is shown, if we're inside that tab, trigger a resize to
   * properly fit to the viewport.
   */
  onTabShown(event) {
    var target = event.target;
    var id = target.getAttribute('aria-controls');
    if (id) {
      var tabTarget = document.getElementById(id);
      if (tabTarget && tabTarget.contains(this.chart.current)) {
        this.onResize();
      }
    }
  }

  /**
   * We've received new data from the outside, update the chart.
   */
  componentDidUpdate() {
    if (this.props.data && this.chartInstance) {
      var xAxisLabel = [];
      var values = [];

      for (var i = 0; i < this.props.data.length; i++) {
        xAxisLabel.push(this.props.data[i][0]);
        values.push(this.props.data[i][1]);
      }

      var options = {
        title: { show: false },
        tooltip: {
          trigger: 'axis',
          valueFormatter: function(value) {
            return CurrencyFormat(value);
          },
          formatter: function(params) {
            var dataPoint = params[0];
            return '<strong>' + tooltipDateFormat(dataPoint.name) + '</strong><br />' +
              dataPoint.seriesName + ': ' + CurrencyFormat(dataPoint.value);
          }
        },
        xAxis: {
          data: xAxisLabel,
          axisLabel: {
            formatter: function(value) {
              return dateAxisFormat(value);
            }
          }
        },
        yAxis: {
          scale: true,
          boundaryGap: ['5%', '5%'],
          axisLabel: {
            inside: true,
            formatter: function(value, index) {
              if (! index) {
                return '';
              } else {
                return CurrencyFormat(value);
              }
            },
            margin: 0
          }
        },
        series: [
          {
            name: 'Price (USD)',
            data: values,
            type: 'line'
          }
        ]
      };

      this.chartInstance.setOption(options);
    }
  }

  componentDidMount() {
    var chart = echarts.init(this.chart.current);

    this.chartInstance = chart;

    // ensure we trigger changes in the chart when the screen resizes
    window.addEventListener('resize', this.onResize);
    // also, if we're placed within a bootstrap tabs, we need to recalculate
    // when our tab is selected.
    jQuery(window).on('shown.bs.tab', this.onTabShown);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    jQuery(window).off('shown.bs.tab', this.onTabShown);
  }

  render() {
    return <div ref={this.chart} className="cs-asset-chart__chart" />;
  }
}


class AssetChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: undefined,
      data: undefined,
      timestamp: 0
    };

    this.validateResponse = this.validateResponse.bind(this);
    this.fetchComplete = this.fetchComplete.bind(this);
  }

  componentDidMount() {
    if (this.props.id) {
      var requestUrl = 'https://api.coingecko.com/api/v3/coins/' + this.props.id + '/market_chart';
      requestUrl = Request.updateQueryStringParameter(requestUrl, 'vs_currency', 'usd');
      requestUrl = Request.updateQueryStringParameter(requestUrl, 'days', '60');
      requestUrl = Request.updateQueryStringParameter(requestUrl, 'interval', 'daily');

      window.fetch(requestUrl)
        .then(this.validateResponse)
        .then(this.fetchComplete);
    } else {
      this.setState({
        loading: false,
        error: 'No Asset ID specified.'
      });
    }
  }

  validateResponse(response) {
    if (response.status === 200) {
      return response.json();
    } else {
      this.setState({
        loading: false,
        error: 'API Status "' + response.status + '".'
      });

      return undefined;
    }
  }

  fetchComplete(data) {
    var result = undefined;

    if (data && data.prices) {
      result = [];
      for (var i = 0; i < data.prices.length; i++) {
        result.push([
          data.prices[i][0],
          data.prices[i][1].toFixed(2)
        ]);
      }
    }

    this.setState({
      loading: false,
      data: result,
      timestamp: Math.floor(Date.now() / 1000)
    });
  }

  render() {
    var content = [];

    content.push(
      <LineChart key="chart" data={this.state.data} />
    );

    if (this.state.loading) {
      content.push(
        <div key="loading" className="cs-asset-chart__loading">
          <Spinner />
        </div>
      );
    } else {
      if (this.state.error) {
        content.push(
          <div key="error" className="cs-asset-chart__loading">
            <Alert variant="danger">
              <Alert.Heading>Error:</Alert.Heading>
              {this.state.error}
            </Alert>
          </div>
        );
      }
    }


    return (
      <div className="cs-asset-chart">
        <div className="cs-asset-chart__wrapper">
          {content}
          <div className="cs-asset-chart__updated">
            <UpdatedPopover timestamp={this.state.timestamp} />
          </div>
        </div>
      </div>
    );
  }
}


export default AssetChart;

